var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',{staticClass:"mfs-auto"},[_c('span',{staticClass:"mr-1",attrs:{"target":"_blank"}},[_vm._v("Desenvolvido por")]),_c('a',{attrs:{"href":"https://versotech.com.br"}},[_vm._v("Versotech - Soluções em tecnologia")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }